import { Box, Checkbox, FormControl } from '@primer/react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import SelectBoxHocSinh from '../../../../components/selectbox-hocsinh';
import Button from '../../../../components/ui/button';
import Modal from '../../../../components/ui/modal';
import ModalActions from '../../../../components/ui/modal/ModalActions';
import Text from '../../../../components/ui/text';
import TextAreaAutoHeight from '../../../../components/ui/text-area-auto-height';
import { useCommonSelectedHook } from '../../../../hooks/useCommonSelectedHook';
import { ePageBaseStatus } from '../../../../models/ePageBaseStatus';
import { IHocSinhAceChitietVM } from '../../../../models/response/hoc-sinh/IHocSinhAceChitiet';
import { actions } from '../../../../state/actions/actionsWrapper';
import { RootState } from '../../../../state/reducers';
import { IHocSinhAceChiTietSubmit } from '../../../../models/request/hoc-sinh/IHocSinhAceChiTietSubmit';
import { HocSinh } from '../QuanHeGiaDinhHocSinh';
import SelectBoxMienGiam from '../../../../components/selectbox-miengiam';
interface Props {
    hocSinh: HocSinh;
    onSuccess?: () => void;
}
const AnhChiEmEditModal: React.FC<Props> = ({ hocSinh, onSuccess }) => {
    const { status, editingData } = useSelector((x: RootState) => x.hocSinhAceChiTiet)
    const dispatch = useDispatch();
    const { dm_coso_id, nam_hoc } = useCommonSelectedHook();
    const { handleSubmit, setValue, watch, control, formState: { errors } } = useForm<IHocSinhAceChitietVM>({
        defaultValues: editingData ? {
            ...editingData,
        } : undefined
    })

    // Listen for successful save and call onSuccess callback
    useEffect(() => {
        if (status === ePageBaseStatus.is_need_reload && onSuccess) {
            onSuccess();
        }
    }, [status, onSuccess])
    const onSubmit = async (data: any) => {
        const datasend: IHocSinhAceChiTietSubmit = {
            nam_hoc: nam_hoc,
            ts_hocsinh_id: hocSinh.id,  // ID của học sinh gốc
            ts_hocsinh_ace_chitiet: {
                ...data,
                ts_hocsinh_id: data.ts_hocsinh_id  // ID của anh chị em được chọn
            }
        }
        dispatch(actions.hocSinhAceChiTiet.SAVE_START(datasend))
    }

    // const onSubmit = async (data: any) => {
    //     debugger

    //     const datasend: IHocSinhAceChiTietSubmit = {
    //         nam_hoc: nam_hoc,
    //         ts_hocsinh_id: hocSinh.id,
    //         ts_hocsinh_ace_chitiet: data
    //     }
    //     dispatch(actions.hocSinhAceChiTiet.SAVE_START(datasend))
    // }

    return (
        <Modal isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.hocSinhAceChiTiet.CLOSE_EDIT_MODAL(undefined))
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label><Text text='Anh chị em' /></FormControl.Label>
                        <Controller
                            name="ts_hocsinh_id"
                            control={control}
                            rules={{
                                required: {
                                    value: true,
                                    message: ""
                                }
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <>
                                    <SelectBoxHocSinh
                                        isReadonly={editingData !== undefined && editingData.id > 0}
                                        value={field.value}
                                        isShowClearBtn={true}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                        }}
                                        width={'100%'}
                                    />
                                    {
                                        errors && errors["ts_hocsinh_id"] &&
                                        <FormControl.Validation variant="error">
                                            Vui lòng chọn anh chị em
                                        </FormControl.Validation>
                                    }
                                </>
                            )}
                        />

                    </FormControl>

                    <FormControl sx={{ pt: 1 }}>
                        <FormControl.Label>Hưởng ưu đãi</FormControl.Label>
                        <Checkbox
                            checked={watch("is_huonguudai", editingData?.is_huonguudai)}
                            onChange={(e) => {
                                setValue("is_huonguudai", e.target.checked);
                            }}
                        />
                    </FormControl>
                    {watch("is_huonguudai", editingData?.is_huonguudai) && (
                        <FormControl sx={{ pt: 1 }}>
                            <FormControl.Label>
                                <Text text="Ưu đãi, miễn giảm" />
                            </FormControl.Label>

                            <Controller
                                name="sf_hinhthucmiengiam_id"
                                control={control}
                                rules={{
                                    required: {
                                        value: true,
                                        message: ""
                                    }
                                }}
                                render={({ field }) => (
                                    <>
                                        <SelectBoxMienGiam
                                            value={field.value}
                                            isShowClearBtn={true}
                                            onValueChanged={(value) => {
                                                field.onChange(value);
                                            }}
                                            width={"100%"}
                                        />
                                        {
                                            errors && errors["sf_hinhthucmiengiam_id"] &&
                                            <FormControl.Validation variant="error">
                                                Vui lòng chọn ưu đãi miễn giảm được hưởng
                                            </FormControl.Validation>
                                        }
                                    </>
                                )}
                            />


                        </FormControl>
                    )}
                    <FormControl>
                        <FormControl.Label>
                            Ghi chú
                        </FormControl.Label>
                        <Controller
                            name="ghi_chu"
                            control={control}
                            rules={{
                                required: {
                                    value: false,
                                    message: ""
                                }
                            }}
                            render={({ field }) => (
                                <TextAreaAutoHeight
                                    defaultValue={field.value}
                                    isAutoFocus
                                    sx={{
                                        width: "100%"
                                    }}
                                    resize="none"
                                    onValueChanged={(value) => {
                                        field.onChange(value)
                                    }}
                                />
                            )}
                        />
                    </FormControl>
                </Box>

                <ModalActions>

                    <Button
                        text='Base.Label.Close' variant="default"
                        leadingVisual={'center'}
                        size="small"
                        onClick={() => {
                            dispatch(actions.hocSinhAceChiTiet.CLOSE_EDIT_MODAL(undefined))
                        }} />
                    <Button
                        text='Base.Label.Update' variant="primary"
                        size="small"
                        type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>

        </Modal>
    );
};

export default AnhChiEmEditModal;